/**
 * tokenErrorConstants
 *
 */
const constantPrefix = 'TOKEN_ERROR';
export default {
  INCREMENT: "".concat(constantPrefix, "_INCREMENT"),
  RESET: "".concat(constantPrefix, "_RESET"),
  RETRY_ON_SUCCESS: "".concat(constantPrefix, "_RETRY_ON_SUCCESS")
};